import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useState } from "react";
import StatusEstabelecimento from "../../utils/status/statusEstabelecimento";
import ImagemEdit from "../../utils/imagemEdit";
import ChangeStatusEstabelecimento from "../gestAdmin/changeStatusEstabelecimento";
import Relatorios from "../../relatorioEspontaneo/relatoriosEspontaneos";

const NAV_ITEMS = [
  { label: 'Informações Gerais',      path: (id) => `/admin/gestor-licenciados/${id}` },
  { label: 'Autorização de Exercício', path: (id) => `/admin/autorizacao-de-exercicio/${id}` },
  { label: 'Inspecções',              path: (id) => `/admin/gestor-licenciados/inspecao/${id}` },
  { label: 'Observações',             path: (id) => `/admin/gestor-licenciados/observacoes/${id}` },
  { label: 'Solicitações',            path: (id) => `/admin/gestor-licenciados/solicitacoes/${id}` },
  { label: 'Históricos',              path: (id) => `/admin/gestor-licenciados/historicos/${id}` },
];

export default function NavLateral({ estabelecimento, thisId, buttonNhangeStatus = true }) {
  const url = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const activeId = thisId ?? id;
  const [status, setStatus] = useState(estabelecimento.status);

  const handleStatusChange = (newStatus) => {
    setStatus(newStatus);
    window.location.reload();
  };

  return (
    <div className="tw-flex tw-flex-col tw-gap-3">

      {/* ── Cartão do estabelecimento ── */}
      <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-p-4">

        {/* Foto */}
        <div className="tw-flex tw-justify-center tw-mb-3">
          <ImagemEdit
            data={estabelecimento}
            url="/estabelecimento/change-logo"
            local="estabelecimentoId"
            openEditLogo={false}
          />
        </div>

        {/* Badge licenciado */}
        <div className="tw-flex tw-items-center tw-justify-center tw-gap-1.5 tw-mb-3">
          <img src="/icones/licenciamento.svg" alt="licenciado" width={18} />
          <span className="tw-text-[11px] tw-font-semibold tw-text-gray-500 tw-uppercase tw-tracking-wide">
            Estabelecimento Licenciado
          </span>
        </div>

        {/* Status */}
        <StatusEstabelecimento status={status} />

        {/* Botão alterar status */}
        {buttonNhangeStatus && (
          <div className="tw-mt-3">
            <ChangeStatusEstabelecimento
              estabelecimentoId={estabelecimento?._id}
              currentStatus={status}
              onStatusChange={handleStatusChange}
            />
          </div>
        )}
      </div>

      {/* ── Menu de navegação ── */}
      <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-overflow-hidden">
        <nav className="tw-flex tw-flex-col">
          {NAV_ITEMS.map(({ label, path }) => {
            const isActive = url.pathname === path(activeId);
            return (
              <button
                key={label}
                onClick={() => navigate(path(activeId))}
                className={[
                  'tw-w-full tw-text-left tw-px-4 tw-py-2.5 tw-text-sm tw-font-medium',
                  'tw-transition-all tw-duration-200 tw-border-b tw-border-gray-50 last:tw-border-0',
                  isActive
                    ? 'tw-bg-[#85287e]/10 tw-text-[#85287e] tw-font-semibold tw-border-l-2 tw-border-l-[#85287e]'
                    : 'tw-text-gray-700 hover:tw-bg-gray-50 hover:tw-text-[#85287e]',
                ].join(' ')}
              >
                {label}
              </button>
            );
          })}
        </nav>
      </div>

      {/* ── Relatórios Espontâneos ── */}
      <Relatorios processoId={activeId} modelName="estabelecimentos" />
    </div>
  );
}
